// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .grid-item-lightgreen {
  background-color: lightgreen;
}
::ng-deep .grid-item-lightblue {
  background-color: lightblue;
}
::ng-deep .grid-item-fiolet {
  background-color: rgb(221, 189, 244);
}
::ng-deep .grid-item-lightpink {
  margin-top: 20px;
  background: lightpink;
}
::ng-deep .grid-item-320 {
  width: 320px !important;
  max-width: 320px !important;
  min-width: 320px !important;
}
::ng-deep .margin-left-5 {
  left: 5px !important;
}
::ng-deep .margin-top-15 {
  margin-top: 15px;
}

.container {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  max-width: 1100px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/layouts/layouts/layouts.component.scss","webpack://./../mydocma-dynamic-form-app%20(dev)/src/app/components/layouts/layouts/layouts.component.scss"],"names":[],"mappings":"AACI;EACI,4BAAA;ACAR;ADGI;EACI,2BAAA;ACDR;ADII;EACI,oCAAA;ACFR;ADKI;EACI,gBAAA;EACA,qBAAA;ACHR;ADMI;EACI,uBAAA;EACA,2BAAA;EACA,2BAAA;ACJR;ADOI;EACI,oBAAA;ACLR;ADQI;EACI,gBAAA;ACNR;;ADUA;EACI,cAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,iBAAA;ACPJ","sourcesContent":["::ng-deep {\r\n    .grid-item-lightgreen {\r\n        background-color: lightgreen;\r\n    }\r\n\r\n    .grid-item-lightblue {\r\n        background-color: lightblue;\r\n    }\r\n\r\n    .grid-item-fiolet {\r\n        background-color: rgb(221, 189, 244);\r\n    }\r\n\r\n    .grid-item-lightpink {\r\n        margin-top: 20px;\r\n        background: lightpink;\r\n    }\r\n\r\n    .grid-item-320 {\r\n        width: 320px !important;\r\n        max-width: 320px !important;\r\n        min-width: 320px !important;\r\n    }\r\n\r\n    .margin-left-5 {\r\n        left: 5px !important;\r\n    }\r\n\r\n    .margin-top-15 {\r\n        margin-top: 15px;\r\n    }\r\n}\r\n\r\n.container {\r\n    margin: 0 auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    width: 100%;\r\n    max-width: 1100px;\r\n}\r\n","::ng-deep .grid-item-lightgreen {\n  background-color: lightgreen;\n}\n::ng-deep .grid-item-lightblue {\n  background-color: lightblue;\n}\n::ng-deep .grid-item-fiolet {\n  background-color: rgb(221, 189, 244);\n}\n::ng-deep .grid-item-lightpink {\n  margin-top: 20px;\n  background: lightpink;\n}\n::ng-deep .grid-item-320 {\n  width: 320px !important;\n  max-width: 320px !important;\n  min-width: 320px !important;\n}\n::ng-deep .margin-left-5 {\n  left: 5px !important;\n}\n::ng-deep .margin-top-15 {\n  margin-top: 15px;\n}\n\n.container {\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 100%;\n  max-width: 1100px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
